export default {
  priority: 11,
  path: "user",
  permissions: [
    "TimeAttendanceMenu/SmsMenu",
    "afa244366dafa24366d32ebde43b4a30068dccc68a779b3ac8543aea48e320b22d99f1895932ebde43b4a30068dccc68a779b3ac8543aea48e320b22d99f18959",
  ],
  // component: Users,
  // component: load(() =>
  //   import(/* webpackChunkName: "Setting-Users" */ "./Sms")
  // ),
  name: app.translate("پیامک"),
  icon: "account-check",
  drawer: true,
  description: `فیش حقوقی: امکان مشاهده فایل PDF فیش حقوقی در این منو وجود دارد. پس از انجام محاسبات حقوق و ایجاد آنها در قالب مشخصی که به نام گذاری فایل‌ها مربوط می شود و قراردادن آنها در محل مورد نظر در سرور نرم افزار،‌ هر پرسنل می تواند به فایل فیش حقوقی ماه و سال مورد نظر خود دسترسی داشته باشد. 
این موضوع می تواند مراجعات به واحد مالی را کاهش داده، همچنین از هزینه های مربوط به چاپ فیش حقوقی نیز بکاهد.`,
};
